import React from 'react';
import {SvgIcon} from 'svg/SvgIcon';
import coincidentContent from './coincident-constraint.svg';
import distanceplContent from './distancepl-constraint.svg';
import horizontalContent from './horizontal-constraint.svg';
import parallelContent from './parallel-constraint.svg';
import perpendicularContent from './perpendicular-constraint.svg';
import polContent from './point-on-line-constraint.svg';
import verticalContent from './vertical-constraint.svg';
import distanceContent from './distance-constraint.svg';
import equalContent from './equal-constraint.svg';
import tangentContent from './tangent-constraint.svg';
import radiusContent from './radius-constraint.svg';
import pointOnCurveContent from './point-on-curve-constraint.svg';
import pointInMiddleContent from './point-in-middle-constraint.svg';
import symmetryContent from './symmetry-constraint.svg';
import angleBetweenContent from './angle-between-constraint.svg';
import angleContent from './angle-constraint.svg';
import lockContent from './lock-constraint.svg';
import filletContent from './fillet-constraint.svg';
import genericContent from './generic-constraint.svg';

export function CoincidentConstraintIcon(props) {

  return <SvgIcon content={coincidentContent} {...props} />
}

export function DistancePLConstraintIcon(props) {

  return <SvgIcon content={distanceplContent} {...props} />
}

export function HorizontalConstraintIcon(props) {

  return <SvgIcon content={horizontalContent} {...props} />
}

export function ParallelConstraintIcon(props) {

  return <SvgIcon content={parallelContent} {...props} />
}

export function PerpendicularConstraintIcon(props) {

  return <SvgIcon content={perpendicularContent} {...props} />
}

export function PointOnLineConstraintIcon(props) {

  return <SvgIcon content={polContent} {...props} />
}

export function VerticalConstraintIcon(props) {

  return <SvgIcon content={verticalContent} {...props} />
}

export function DistanceConstraintIcon(props) {

  return <SvgIcon content={distanceContent} {...props} />
}

export function EqualConstraintIcon(props) {

  return <SvgIcon content={equalContent} {...props} />
}

export function TangentConstraintIcon(props) {

  return <SvgIcon content={tangentContent} {...props} />
}

export function RadiusConstraintIcon(props) {

  return <SvgIcon content={radiusContent} {...props} />
}

export function PointOnCurveConstraintIcon(props) {

  return <SvgIcon content={pointOnCurveContent} {...props} />
}

export function PointInMiddleConstraintIcon(props) {

  return <SvgIcon content={pointInMiddleContent} {...props} />
}

export function SymmetryConstraintIcon(props) {

  return <SvgIcon content={symmetryContent} {...props} />
}

export function AngleBetweenConstraintIcon(props) {

  return <SvgIcon content={angleBetweenContent} {...props} />
}

export function AngleConstraintIcon(props) {

  return <SvgIcon content={angleContent} {...props} />
}

export function LockConstraintIcon(props) {

  return <SvgIcon content={lockContent} {...props} />
}

export function FilletConstraintIcon(props) {

  return <SvgIcon content={filletContent} {...props} />
}

export function GenericConstraintIcon(props) {

  return <SvgIcon content={genericContent} {...props} />
}